import React, { useState, useEffect } from 'react';
import './create-edit-mechanics.styles.scss';

import treasure from '@/assets/treasure.png';
import podium from '@/assets/podium.png';
import full_game from '@/assets/full_game.png';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ModalAlert } from '@/components/modal/modal.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import StartingPointModal from './starting-point-modal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const CreateEditMechanics = ({ 
    edit, 
    formData, 
    saveData, 
    verifyAndMoveOn, 
    cancel, 
    validJoinCode 
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const membership = useSelector(state => state.userData.membership);
    const [ req ] = useState([]);
    const [ showUpgradeModal, setShowUpgradeModal ] = useState(null);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ showStartingPoint, setShowStartingPoint ] = useState(false);
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (!formData.gameName) {
    //         navigate('/home/creategame');
    //     }
    // }, [formData])

    function chooseType(e) {
        if (e === 'full' && membership.membership === 0) {
            setShowUpgradeModal('Sorry! You must upgrade your account to be able to take advantage of the full range of game elements in the platform!');
            return;
        }       
        // saveData('type', e);
        saveData(
            'access', 
            [
                'points', 
                'leaderboards', 
                'levels', 
                'badges', 
                'currency', 
                'marketplace', 
                'items', 
            ]
        );
        saveData('sortLeaders', 'points');
    }

    function continueCreate() {
        // if (!formData.type) {
        //     setAlertMessage('Please choose a game type before continuing.');
        //     return;
        // }
        verifyAndMoveOn(req, 'name');
    }

    return (
        <div className={`new-game-form create-mechanics ${screenSize}`}>
            <h3>Choose What Game Mechanics You Want to Use</h3>
            <div className="g-space-1"></div>
            <div className={`g-list-item game-type-card ${formData.type === 'currency' ? 'active': ''}`} >
                <div className='image-grid'>
                    <img src={treasure} />
                </div>
                <div className='explanation-grid'>
                    <h3>Limited Free Game</h3>
                    <p>Games created by users with Basic Accounts have access to a limited set of game mechanics.</p>
                    <div className='g-double-col'>
                        <ul>
                            <li>Up to 50 players</li>
                            <li>Up to 50 game elements</li>
                            <li>Points and Leaderboards</li>
                        </ul>
                        <ul>
                            <li>Levels and Badges</li>
                            <li>Secret Codes</li>
                            <li>Marketplace and Items</li>
                        </ul>
                    </div>
                    <div className="g-space-"></div>
                    <div className='buttons'>
                        <button 
                            className={`g-button primary ${screenSize !== 'desktop' ? 'med-btn' : ''}`}>
                            Selected
                        </button>
                    </div>
                </div>
            </div>
            {/* <div className="g-space-20"></div>
            <div className={`g-list-item game-type-card ${formData.type === 'points' ? 'active': ''}`} >
                <div className='image-grid'>
                    <img src={podium} />
                    
                </div>
                <div className='explanation-grid'>
                    <h3>Points and Leaderboards</h3>
                    <p>Players earn Experience Points by finding secret codes and completing challenges. Their progress is tracked on a leaderboard and they can earn badges and level up!</p>
                    {
                        (screenSize === 'mobile') &&
                        <div className='g-space-1'></div>
                    }
                    <div className='buttons'>
                        <button 
                            className={`g-button ${screenSize !== 'desktop' ? 'med-btn' : ''}`}
                            onClick={() => chooseType('points')}>
                            Select
                        </button>
                    </div>
                </div>
            </div> */}
            <div className="g-space-20"></div>
            <div 
                className={`g-list-item game-type-card ${
                    formData.type === 'full' ? 
                    'active' : 
                    ''
                }`} 
            >
                <div className='image-grid'>
                    <img src={full_game} />
                    
                </div>
                <div className={`explanation-grid`}>
                    <div className='explanation-head'>
                        <h3>Full Featured Game!</h3>
                        {
                            (membership && membership.membership === 0) &&
                            <span className='meta'>
                                <button 
                                    className='g-button text-only' 
                                    onClick={() => setShowUpgradeModal(true)}>    
                                    Paid Plans Only
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                </button>
                            </span>
                        }
                    </div>
                    <p>Users with Pro, Premium, or Enterprise memberships can access all game elements and have fewer restrictions on player and game element counts.</p>
                    {
                        (screenSize === 'mobile') &&
                        <div className='g-space-1'></div>
                    }
                    <div 
                        className='buttons'
                        // onClick={() => membership && membership.membership === 0 ? setShowUpgradeModal(true) : null}>
                       >
                        <Link to='/pricing' target='_blank'>
                            <button 
                                className={`g-button ${screenSize !== 'desktop' ? 'med-btn' : ''}`}>
                                Learn more
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="g-space-2"></div>
            {/* <hr /> */}
            <div className='buttons'>
                <button 
                    className={`g-button ${
                        screenSize === 'mobile' 
                        ? 'med-btn' 
                        : ''}`} 
                    onClick={() => cancel()}>
                    Cancel
                </button>
                <button 
                    className={`g-button primary ${
                        screenSize === 'mobile' 
                        ? 'med-btn' 
                        : ''}`} 
                    onClick={() => continueCreate()}>
                    Next
                </button>
            </div>
            <UpgradeRequiredModal 
                show={showUpgradeModal} 
                cancel={() => setShowUpgradeModal(false)} 
                closeButton={true} 
                message={'You must have a paid membership in order to create a full game with access to more than the basic game elements.'} 
                newTab={true} />
            <StartingPointModal
                show={showStartingPoint}
                cancel={() => setShowStartingPoint(false)}
                verifyAndMoveOn={verifyAndMoveOn} />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default CreateEditMechanics;